<template>
<div>
	<form @submit.prevent="validateBeforeSubmit">

		<div class="form-group row">
			<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Fabricante:</label>
			<div class="col-sm-10">
				<select name="fabricante"
						v-validate="'required'"
						:class="{'is-invalid' : errors.has('fabricante')}"
						v-model="form.fabricante"
						class="form-control form-control-sm">
					<option value="">ESCOLHA</option>
					<option v-for="item in fabricantes" :key="item.id" :value="item">{{item.descricao}}</option>
				</select>
				<span  class="invalid-feedback" v-show="errors.has('fabricante')">{{ errors.first('fabricante') }}</span>
			</div>
		</div>

		<div class="form-group row">
			<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Descrição:</label>
			<div class="col-sm-10">
				<input type="text"
						name="descricao"
						v-validate="'required'"
						:class="{'is-invalid' : errors.has('descricao')}"
						v-model="form.descricao"
						class="form-control form-control-sm">
				<span  class="invalid-feedback" v-show="errors.has('descricao')">{{ errors.first('descricao') }}</span>
			</div>
		</div>

		<!-- <div class="row form-group">
			<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">Contadores:</label>
			<div class="col-sm-10">

				<select v-model="contador"
						autocomplete="off"
						class="form-control form-control-sm"
						name="contador"
						@change="addContador(contador)"
						:class="{'is-invalid' : errors.has('contador')}"   >
					<option value="">Escolha</option>
					<option v-for="(item, index) in contadores" :key="index" :value="item">{{item}}</option>
				</select>
				<span  class="invalid-feedback" v-show="errors.has('contador')">{{ errors.first('contador') }}</span>

				<div>
					<button class="btn btn-sm btn-outline-primary" type="button"
						@click="clickRemoverContator(index, item)"
						style="margin-right:5px; margin-bottom:5px; margin-top:5px"
						v-for="(item, index) in form.contadores" :key="index">
						{{item.descricao}} <fa-icon icon="times"></fa-icon>
					</button>
				</div>
			</div>
		</div> -->

		<div v-if="form.fabricante.tipo == 'M'">
			<div class="form-group row">
				<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">* Tipo:</label>
				<div class="col-sm-10">
					<select name="Tipo"
							v-validate="'required'"
							:class="{'is-invalid' : errors.has('Tipo')}"
							v-model="form.tipoMotor"
							class="form-control form-control-sm">
						<option value="">ESCOLHA</option>
						<option value="REACAO">REAÇÃO</option>
						<option value="PISTAO">PISTÃO</option>
					</select>
					<span  class="invalid-feedback" v-show="errors.has('Tipo')">{{ errors.first('Tipo') }}</span>
				</div>
			</div>

			<div class="form-group row" v-if="form.tipoMotor == 'REACAO'">
				<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">* Tipo do Ciclo:</label>
				<div class="col-sm-10">
					<select name="tipo do ciclo"
							v-validate="'required'"
							:class="{'is-invalid' : errors.has('tipo do ciclo')}"
							v-model="form.tipoCiclo"
							class="form-control form-control-sm">
						<option value="">ESCOLHA</option>
						<option value="C">CICLO</option>
						<option value="C/NG/NF">CICLO / NG e NF</option>
						<option value="NG/NF">NG e NF</option>
					</select>
					<span  class="invalid-feedback" v-show="errors.has('tipo do ciclo')">{{ errors.first('tipo do ciclo') }}</span>
				</div>
			</div>

			<div class="form-group row">
				<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">* APU?</label>
				<div class="col-sm-10">
					<select name="apu"
							v-validate="'required'"
							:class="{'is-invalid' : errors.has('apu')}"
							v-model="form.apu"
							class="form-control form-control-sm">
						<option value="">ESCOLHA</option>
						<option :value="true">SIM</option>
						<option :value="false">NÃO</option>
					</select>
					<span  class="invalid-feedback" v-show="errors.has('apu')">{{ errors.first('apu') }}</span>
				</div>
			</div>
		</div>

		<hr />

		<div class="row">
			<div class="col-sm-12 text-right">
				<small class="float-left text-info"><fa-icon icon="info-circle" transform="left-3" />Campos com * são obrigatórios.</small>
				<button class="btn btn-success btn-sm">
					<fa-icon icon="check" transform="left-3" /> SALVAR
				</button>
			</div>
		</div>
	</form>
</div>
</template>

<script>
import _ from 'lodash'
import axios from '../../../routers/axios'
export default {

    data(){
        return {
			fabricantes: [],
            form: {
                id: 0,
				descricao: "",
				fabricante: "",
				tipoMotor: "",
				tipoCiclo: "",
				apu: false,
				contadores: [],
			},

			contadoresExcluir: [],
			contadoresNovos: [],

			contador: "",

			contadores: ['CSN1', 'CSN2', 'CSN3', 'DAY_WITHOUT_USE', 'TSN', 'TSO', 'TSM', 'TSI', 'CRD'],
        }
    },

    mounted () {
		axios.get(this._getUrl('api/fabricante')).then(response => {
			this.fabricantes = response.data
		})
    },

    methods: {

        editar (item) {
            this.form.id = item.id
			this.form.descricao = item.descricao
			this.form.tipoCiclo = item.tipoCiclo
			this.form.tipoMotor = item.tipoMotor
			this.form.apu = item.apu
			this.form.fabricante = item.fabricante
			this.form.contadores = item.contagem

		},

		clickRemoverContator(index, item){

			if(this.form.contadores[index].id != 0){
				this.contadoresExcluir.push(item)
			}

			this.form.contadores.splice(index, 1)
		},

		addContador(contador){

			let index = _.findIndex(this.form.contadores, o => { return o.descricao == contador})

			if(index == -1){

				let novoContador = { id: 0, idModelo: 0, descricao: contador }

				this.form.contadores.push(novoContador)
				this.contadoresNovos.push(novoContador)
			} else {
				this.$notify.show('warning', 'Já adicionado. ')
			}

			this.contador = ''

		},

        validateBeforeSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.salva();
                }
            });
		},

		atualizaContadores(response){

			// se não tiver q excluir e novos
			if(this.contadoresNovos.length == 0 && this.contadoresExcluir.length == 0){
				this.concluiSalvamento(response)
			}

			let qtd = this.contadoresNovos.length + this.contadoresExcluir.length

			if(this.contadoresNovos.length > 0){

				this.contadoresNovos = this.contadoresNovos.map(item => {
					item.idModelo = this.form.id

					axios.post(this._getUrl('api/contagem/'), item).then(res => {
						this.$notify.loadIn('Salvando')
						qtd -= 1

						if(qtd == 0){
							this.concluiSalvamento(response)
						}

					})

					return item
				})
			}

			if(this.contadoresExcluir.length > 0){

				this.contadoresExcluir = this.contadoresExcluir.map(item => {
					this.$notify.loadIn('Salvando')
					item.idModelo = this.form.id

					axios.delete(this._getUrl('api/contagem/' + item.id)).then(res => {
						qtd -= 1

						if(qtd == 0){
							this.concluiSalvamento(response)
						}

					})

					return item
				})
			}

		},

		concluiSalvamento(response){

			this.contadoresExcluir = []
			this.contadoresNovos = []

			axios.get(this._getUrl('api/modelocontagem') + '/' + response.id).then(res => {
				response.contagem = res.data
				this.form.contadores = res.data
				this.$emit('item-salvo', response)
			})
		},

        salva(){

            var data = {
                id: this.form.id,
				descricao: this.form.descricao,
				idFabricante: this.form.fabricante.id,
				tipoCiclo: this.form.tipoCiclo,
				tipoMotor: this.form.tipoMotor,
				apu: this.form.apu
            }

            this.$notify.loadIn('Salvando')

            if(this.form.id != 0){

                axios.put(this._getUrl('api/modelo') + '/' + this.form.id, data).then(response => {
					// this.$emit('item-salvo', response.data)
					this.atualizaContadores(response.data)
                })

            } else {

                axios.post(this._getUrl('api/modelo'), data).then(response => {
					this.form.id = response.data.id
					this.atualizaContadores(response.data)
                    // this.$emit('item-salvo', response.data)
                })
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/views/followair/modelo/cadastro.vue